import { type AtticErrorFragment } from "@dashboard/graphql";
import commonErrorMessages from "@dashboard/utils/errors/common";
import { type IntlShape } from "react-intl";

/**
 * The backend's own sentence, rendered verbatim like every attic section
 * does (src/fragments/atticErrors.ts); a generic line for a payload that
 * carries a code and no sentence.
 */
export const getAtticInventoryErrorMessage = (
  error: AtticErrorFragment | undefined,
  intl: IntlShape,
): string | undefined => {
  if (!error) {
    return undefined;
  }

  return error.message || intl.formatMessage(commonErrorMessages.unknownError);
};

/** The refusal the backend attributed to `field`, if any. */
export const getAtticInventoryFieldError = (
  errors: AtticErrorFragment[],
  field: string,
): AtticErrorFragment | undefined => errors.find(error => error.field === field);
